import { render } from "./TimeTableFavoriteCard.vue?vue&type=template&id=210a7e7c&scoped=true"
import script from "./TimeTableFavoriteCard.vue?vue&type=script&lang=js"
export * from "./TimeTableFavoriteCard.vue?vue&type=script&lang=js"

import "./TimeTableFavoriteCard.vue?vue&type=style&index=0&id=210a7e7c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210a7e7c"]])

export default __exports__